/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RisksStatistics200Response
 */
export interface RisksStatistics200Response {
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof RisksStatistics200Response
     */
    typeCounts?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof RisksStatistics200Response
     */
    severityCounts?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof RisksStatistics200Response
     */
    sourceCounts?: { [key: string]: number; };
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof RisksStatistics200Response
     */
    statusCounts?: { [key: string]: number; };
}

/**
 * Check if a given object implements the RisksStatistics200Response interface.
 */
export function instanceOfRisksStatistics200Response(value: object): value is RisksStatistics200Response {
    return true;
}

export function RisksStatistics200ResponseFromJSON(json: any): RisksStatistics200Response {
    return RisksStatistics200ResponseFromJSONTyped(json, false);
}

export function RisksStatistics200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RisksStatistics200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'typeCounts': json['type_counts'] == null ? undefined : json['type_counts'],
        'severityCounts': json['severity_counts'] == null ? undefined : json['severity_counts'],
        'sourceCounts': json['source_counts'] == null ? undefined : json['source_counts'],
        'statusCounts': json['status_counts'] == null ? undefined : json['status_counts'],
    };
}

  export function RisksStatistics200ResponseToJSON(json: any): RisksStatistics200Response {
      return RisksStatistics200ResponseToJSONTyped(json, false);
  }

  export function RisksStatistics200ResponseToJSONTyped(value?: RisksStatistics200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type_counts': value['typeCounts'],
        'severity_counts': value['severityCounts'],
        'source_counts': value['sourceCounts'],
        'status_counts': value['statusCounts'],
    };
}

